import { deepDiveArticles } from "@/mocks/home";

export default function DeepDive() {
  return (
    <section id="context" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
              <i className="ri-article-line text-sm" />
              Deep Dive
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              背景挖掘 · 深度整理手记
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
              整理方法本身也值得被说明：我们如何取舍节点、如何标注来源、如何区分线索与结论。
            </p>
          </div>
          <a
            href="#context"
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            全部手记
            <i className="ri-arrow-right-line text-base" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:gap-5">
          {deepDiveArticles.map((article) => (
            <article
              key={article.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="w-full overflow-hidden" style={{ height: 190 }}>
                <img
                  src={article.image}
                  alt={`${article.title} 配图`}
                  title={`${article.title} · 黑料大全背景挖掘`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="flex items-center gap-2 text-[11px] font-medium text-primary-700">
                  <i className="ri-bookmark-3-line text-sm" />
                  {article.kicker}
                </span>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {article.title}
                </h3>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{article.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    阅读 {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-700">
                    阅读全文
                    <i className="ri-arrow-right-up-line text-sm" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}